<template>
  <transition name="slide-fade">
    <div v-if="$store.state.showRight" class="right-list">
      <div style="z-index:1034; position:relative" class="right-list__close text-right">
        <i @click="setShowRight(false)">
          <i style="color:#20c997; font-size:1.5rem;" class="fas fa-times-circle"></i>
        </i>
      </div>
      <ul style class="list-group text-left">
        <li class="list-group-item" style="background: #20c997">
          <h5>
            <!-- User: -->
            <span
              style="letter-spacing:0.05em;"
              class="badge badge-primary"
            >{{$store.state.userName}}</span>
            <span
              style="letter-spacing:0.05em;"
              class="badge badge-success"
            >{{$store.state.companyId}}</span>
            <i style="float:right;" class="fas fa-user"></i>
          </h5>
        </li>
        <li @click="gohome" class="list-group-item">
          <i style="float:right" class="fas fa-home"></i>
          {{$t("Home")}}
        </li>
        <li @click="refreshSystem" class="list-group-item">
          <i style="float:right" class="fas fa-sync"></i>
          {{$t("RefreshSystem")}}
        </li>
        <li class="list-group-item disabled">
          <i style="float:right" class="fas fa-cog"></i>
          {{$t("Setting")}}
        </li>
        <li class="list-group-item">
          <div class="form-group">
            <label for>{{$t("Language")}}</label>
            <i style="float:right" class="fas fa-globe"></i>
            <select
              @change="changeLanguage($event)"
              v-model="$store.state.language"
              class="form-control"
              name
              id
            >
              <option
                v-for="l in $store.state.languageList"
                v-bind:key="l.CultureId"
                :value="l.CultureId"
              >{{l.DisplayName}}</option>
            </select>
          </div>
        </li>
        <li @click="logoutGoHome" class="list-group-item">
          {{$t("Logout")}}
          <i style="float:right" class="fas fa-sign-out-alt"></i>
        </li>
      </ul>

      <div @click="setShowRight(false)" class="right-list__bg"></div>
    </div>
  </transition>
</template>
<script>
import http from "@/http";
// import BaseMethod from "@/components/base/StoreInfo.js";
export default {
  // mixins: [BaseMethod],
  name: "RightMenu",
  methods: {
    refreshSystem: function() {
      this.startLoad();
      window.location.href = "/";
      // this.$router.push("/");
      // this.setShowRight(false);
    },
    gohome: function() {
      this.initMenu();
      this.setCurrentFunctionId(null);
      // this.$router.push("/");
      this.$router.push({ name: "mainMenu" });
      this.setShowRight(false);
    },
    logoutGoHome: function() {
      var _this = this;
      _this.startLoad();
      http
        .post("/WebApp/Authenticate/Logout", {})
        .then(res => {
          if (res.data == true) {
            _this.logout();
            window.localStorage["apextoken"] = "";
            _this.$router.push("/login");
            _this.setShowRight(false);
          } else {
            _this.setMessageText("Error");
          }
          _this.endLoad();
        })
        .catch(err => {
          _this.setMessageText("Error");
          _this.endLoad();
        });
    },
    changeLanguage: function(event) {
      window.localStorage["apexlanguage"] = event.target.value;
      let value = event.target.value;
      this.$i18n.locale = value;
      this.refreshMenu();
    }
  }
};
</script>
<style lang="scss" scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.right-list {
  /* padding: 1%; */
  top: 0;
  height: 100%;
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 1031;
  .user-info {
  }
  /* background: #292322; */
  .right-list__bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.7;
    z-index: 1032;
    background: #292322;
  }
  ul {
    width: 50%;
    float: right;
    height: 100%;
    position: relative;
    z-index: 1033;
    background: #333;
    padding: 1%;
  }
}
</style>
